<!-- 참고 : https://lian-yue.github.io/vue-upload-component/#/en/documents
{
  "fileObject": true,
  "size": 12078,
  "name": "일안해.gif",
  "type": "image/gif",
  "active": false,
  "error": "",
  "success": true,
  "postAction": "/front/api/attach",
  "timeout": 0,
  "file": {},
  "response": {
    "fileName": "일안해.gif",
    "fileSize": 12078,
    "fileContentType": "image/gif",
    "attachmentUrl": "cshhmjofnqitsrdfdpyuaz08clliivk3.gif",
    "uuid": "zug3h7srf9goft3vsirpmrnfjffrap"
  },
  "progress": "100.00",
  "speed": 12363,
  "data": {
    "kind": "via_free"
  },
  "headers": {},
  "id": "w64rkc79f28",
  "blob": "blob:http://localhost:8091/d815c7f7-80b9-4099-9dfe-f83464caa4f7",
  "version": 5,
  "xhr": {}
}

-->
<template>
<span>
  <!-- <template v-slot:header="header" v-if="typeof $scopedSlots['header'] !== 'undefined'">
        <slot name="header" :header="header"></slot>
    </template> -->

  <slot name="dropArea" v-bind="{isDropActive : isDropActive(), files}" />

<!--
    <span v-if="typeof $scopedSlots['file'] !== 'undefined'" :key="i">
      <slot :name="['file']" :value="props.item[h.value]" :item="props.item"></slot>
    </span>
    <span v-else :key="i">{{ props.item[h.value] }}</span> -->


  <!-- <span v-for="(file,i) in files" :key="'l2'+i"> -->
    <!-- <img :src="file.blob" width="50" height="50" /> -->
    <!-- <button v-show="file.active" type="button" @click.prevent="$refs.upload.abort(file, {active: false})">Abort</button> -->
    <!-- {{ file.name }} -->
    <!-- <button type="button" @click.prevent="$refs.upload.remove(file)">X</button> -->
  <!-- </span> -->

    <template v-for="file in files">
      <slot name="uploadFile" v-bind="{file, inst: $refs.upload, remove}">
  <!--       {{ file.name }}
        {{ file.size }}
        <button type="button" @click.prevent="remove(file)" :key="file.id">취소</button> -->
      </slot>
    </template>

    <file-upload
      ref="upload"
      :data="{
        kind: kind
      }"
      v-model=files
      :name=name
      :post-action="action"
      @input-file=inputFile
      @input-filter=inputFilter
      :drop="true"
      :multiple="maxFiles != 1"
      :maximum="maxFiles"
      :size="maxFileSizeMB * 1024 * 1024"
    >
      <slot>
        <button type="button">업로드파일선택</button>
      </slot>

    </file-upload>

    <template v-for="file in files">
      <slot name="uploadFileBottom" v-bind="{file, inst: $refs.upload, remove}"/>
    </template>

<!-- {{ $refs.upload && 1 || 0}} // {{ $refs.upload.dropActive  && 1 || 0}} -->

    <!-- <button v-show="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true" type="button">업로드시작</button> -->
    <!-- <button v-show=" $refs.upload &&  $refs.upload.active" @click.prevent="$refs.upload.active = false" type="button">업로드중단</button> -->

    <!-- <button v-if="files.length > 0" @click.prevent="$refs.upload.clear" type="button">취소</button> -->

    <!-- <span v-show="$refs.upload && files && files.length && $refs.upload.uploaded">업로드 완료되었습니다.</span> -->
</span>
</template>

<style>
.file-uploads { overflow: visible !important; }
</style>

<script>
export default {
  props : {
    action: { type: String, required: true },
    value: { type: Object, },
    kind: { type: String, required: true },
    name: { type: String, default: '' },
    required: { type: Boolean, default: false},
    exts: { type: Array, default: ()=>"jpeg,jpe,mp4,zip,jpg,gif,png,webp".split(/,/)},
    autoUpload: { type: Boolean, default: false}, // 파일 선택시 자동으로 업로드 여부
  },
  data () {
    return {
      files: [],
      maxFiles: 1,   //  최대 파일 업로드 갯수. 0 무제한 1 한개만 1 이상은.. 그만큼만
      maxFileSizeMB: 10, // 파일당 최대용량 (메가바이트) ( 0은 무제한 ) -- 1024 * 1024

      callbackFunction: null,
      emitFile: {},
    }
  },
  watch: {
    files: {
      deep: true,
      handler: function (val, oldVal) {
        this.emitValue()
      }
    },
  },
  created() {
    console.log("file : ", this.value)
    console.log("autoUpload = ", this.autoUpload)

  },
  mounted() {
    this.checkDevice()
  },
  methods: {
    isDropActive() { return !!(this.$refs.upload && this.$refs.upload.dropActive) },
    checkExt(filename) {
      if (!filename) return false
      const ext = filename.split('.').pop().toLowerCase();
      return this.exts.some(i=>i==ext)
    },
    start(callBack) {
      this.callbackFunction = callBack || null;
      if (this.required && this.files.length < 1) {
        alert("첨부할 파일을 선택해 주세요.");
        return;
      }
      console.log("xx", this.files.length);

      if (this.files < 1) { // 파일 업로드가 필수가 아니고, 업로드할 파일이 없으면 그냥 바로 완료.
        if (this.callbackFunction) {
          this.done()
        }
      } else {
        this.$refs.upload.active = true
      }
    },
    clear() {
      this.$refs.upload.clear()
      console.log("[I-FILEUPLOAD] 클리어 실행됨");

    },

    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter(newFile, oldFile, prevent) { // 파일 선택시 호출됨

      console.log('[파일업로드컴포넌트] inputFilter() 호출')
      if (newFile && !oldFile) { // 파일 추가시
        console.log('[파일업로드컴포넌트] inputFilter() 파일추가됨')


        if (this.maxFiles > 0 && this.files && this.files.length >= this.maxFiles) {
          alert("더이상 파일을 추가할 수 없습니다.\n최대 갯수 : " + this.maxFiles)
          return prevent() // prevent() 가 호출되면 해당 파일은 반영되지 않는다.
        }

        // Filter non-image file
        // Will not be added to files
        // if (!/\.(jpeg|jpe|mp4|zip|jpg|gif|png|webp)$/i.test(newFile.name)) {
        if (!this.checkExt(newFile.name)) {
          alert("지원되지 않는 파일 형식 입니다 : " + newFile.name)
          return prevent() // prevent() 가 호출되면 해당 파일은 반영되지 않는다.
        }

        if (this.maxFileSizeMB > 0) {
          if (newFile.size >= 0 && newFile.size > this.maxFileSizeMB * 1024 * 1024) { // 파일 용량 체크
            const sizeMBComma = T.comma((newFile.size / 1024 / 1024).toFixed(2))
            alert(`파일 용량이 너무 큽니다.\n파일 : ${ newFile.name } (용량 : ${ sizeMBComma }) MB\n\n* 최대 ${ this.maxFileSizeMB }MB까지 가능.`)
            return prevent() // prevent() 가 호출되면 해당 파일은 반영되지 않는다.
          }
        }

        // 파일을 업로드 하기 전에 메모리상에 blob 를 만들어서 미리보기를 한다.
        // 이런식으로 미리보기 가능 -- <img :src="file.blob" width="50" height="50" />
        if (newFile.type && /image/i.test(newFile.type)) { // 파일이 이미지일때만
          newFile.blob = ''
          let URL = window.URL || window.webkitURL
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file)
          }
        }
      }

      if (newFile && oldFile) { // 파일 교체시
        console.log('[파일업로드컴포넌트] inputFilter() 파일교체됨')
        if (!newFile.version) { // Increase the version number
          newFile.version = 0
        }
        newFile.version++
      }

      if (!newFile && oldFile) { // 파일 제외시(삭제?)
        console.log('[파일업로드컴포넌트] inputFilter() 파일삭제됨')
        // Refused to remove the file
        // return prevent()
      }
    },
    checkDevice() {
      if (this.$device && this.$device.isIE && Number(this.$device.fullBrowserVersion) <= 9) {
        this.$ui.notify("파일업로드가 지원되지 않는 브라우져 입니다.\nIE의 경우 IE 10 이상부터 지원됩니다.")
      }
    },
    /**
     * Has changed
     * @param  Object|undefined   newFile   Read only
     * @param  Object|undefined   oldFile   Read only
     * @return undefined
     */
    inputFile2 (newFile, oldFile) {

      console.log('[파일업로드컴포넌트] inputFile() 시작1..')

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log('inputFile: response', newFile.response)
        if (newFile.xhr) {
          //  Get the response status code
          console.log('inputFile: status', newFile.xhr.status)
        }
      }
    },
    inputFile(newFile, oldFile) {

      console.log('[파일업로드컴포넌트] inputFile() 호출')

      if (newFile && !oldFile) { // Add file
        console.log('[파일업로드컴포넌트] inputFile() 파일 추가 :', newFile)
      }

      if (newFile && oldFile) { // 파일 업로드

        if (!newFile.active && oldFile.active) {
          console.log('[파일업로드컴포넌트] inputFile() response :', newFile.response)
          if (newFile.xhr) {
            console.log('[파일업로드컴포넌트] inputFile() status :', newFile.xhr.status)
          }

          // 업로드 서버 오류 처리
          if (newFile.response) {
            const res = newFile.response
            if (res.type == 'ApiError') {
              this.remove(newFile)
              alert(res.message)
              return
            }
          }

        }

        if (this.maxFileSizeMB > 0) {
          if (newFile.active !== oldFile.active) { // Start upload
            console.log('[파일업로드컴포넌트] inputFile() 업로드 시작 :', newFile.active, newFile)
            if (newFile.size >= 0 && newFile.size > this.maxFileSizeMB * 1024 * 1024) { // 파일 용량 체크
              newFile = this.$refs.upload.update(newFile, {error: 'size'})
            }
          }
        }

        if (newFile.progress !== oldFile.progress) { // 업로드 프로그새ㅡ
          console.log('[파일업로드컴포넌트] inputFile() progress :', newFile.progress, newFile)
        }

        if (newFile.error !== oldFile.error) { // 업로드 오류
          console.log('[파일업로드컴포넌트] inputFile() error :', newFile.error, newFile)
        }

        if (newFile.success !== oldFile.success) { // 업로드 성공
          console.log('[파일업로드컴포넌트] inputFile() success :', newFile.success, newFile)

          if (this.files.every(v=>v.success)) // 모든 파일 업로드 성공
            this.done()
        }
      }

      if (!newFile && oldFile) { // 파일 삭제시
        console.log('[파일업로드컴포넌트] inputFile() : 파일삭제')
        if (oldFile.success && oldFile.response.id) { // 파일 삭제 api 호출
          console.log('[파일업로드컴포넌트] inputFile() : 파일삭제 API 호출 (실제론 하지 않음)')
          // $.ajax({
          //   type: 'DELETE',
          //   url: '/file/delete?id=' + oldFile.response.id,
          // });
        }
      }

      // 자동 업로드
      if (this.autoUpload) {
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (!this.$refs.upload.active) {
            console.log('[파일업로드컴포넌트] inputFile() 자동 업로드 실행!!')
            this.$refs.upload.active = true
          }
        }
      }
    },

    remove(file) {
      this.$refs.upload.remove(file)
    },

    emitValue() {
      if (this.files.length > 0) {
        const file = this.files[0]
        this.emitFile = {
          size: file.size,
          name: file.name,
          type: file.type,
          uuid: file.response.uuid,
          path: file.response.attachmentUrl,
        }
      } else {
        this.emitFile = {}
      }
      this.$emit('input', this.emitFile)
    },

    done() { // 전체 파일 업로드 완료
      console.log('[파일업로드컴포넌트] 전부 업로드 완료~~~~~~~~~~~~~~~~~!!')
      this.emitValue()
      this.$emit('done', this.emitFile)
      if (this.callbackFunction) {
        this.callbackFunction();
      }
    }
  },
}
</script>